import type HttpClient from "../../tastyworks/http"
import {
  RECURRING_INVESTMENT_DESER,
  RECURRING_INVESTMENT_REQUEST_DESER,
  RecurringInvestment,
} from "../../tastyworks/recurring-investment"
import type { PaginationParams } from "../../tastyworks/request"
import type { ItemsResponse, SingleResponse } from "../../tastyworks/response"

const RECURRING_INVESTMENTS_PER_PAGE = 50

export interface RecurringInvestmentIndexParams extends PaginationParams {
  statuses?: string[]
  instrumentTypes?: string[]
}

const parseRecurringInvestment =
  RECURRING_INVESTMENT_DESER.toParser(RecurringInvestment)

export class RecurringInvestmentService {
  constructor(
    private readonly accountNumberClient: HttpClient,
    private readonly customerMeClient: HttpClient
  ) {}

  readonly index = async (
    params: RecurringInvestmentIndexParams = {}
  ): Promise<ItemsResponse<RecurringInvestment>> =>
    this.customerMeClient.indexSimple(
      parseRecurringInvestment,
      "recurring-investments",
      { perPage: RECURRING_INVESTMENTS_PER_PAGE, ...params }
    )

  readonly create = async (
    request: RecurringInvestment
  ): Promise<SingleResponse<RecurringInvestment>> =>
    this.accountNumberClient.create(
      request,
      RECURRING_INVESTMENT_REQUEST_DESER.serialize,
      RECURRING_INVESTMENT_DESER.update,
      "recurring-investments",
      { accountNumber: request.accountNumber }
    )

  readonly update = async (
    request: RecurringInvestment
  ): Promise<SingleResponse<RecurringInvestment>> =>
    this.accountNumberClient.update(
      request,
      RECURRING_INVESTMENT_REQUEST_DESER.serialize,
      RECURRING_INVESTMENT_DESER.update,
      "recurring-investments/:recurringInvestmentId",
      {
        accountNumber: request.accountNumber,
        recurringInvestmentId: request.id,
      }
    )

  readonly dryRunCreate = async (
    request: RecurringInvestment
  ): Promise<SingleResponse<RecurringInvestment>> =>
    this.accountNumberClient.create(
      request,
      RECURRING_INVESTMENT_REQUEST_DESER.serialize,
      RECURRING_INVESTMENT_DESER.update,
      "recurring-investments/dry-run",
      { accountNumber: request.accountNumber }
    )

  readonly dryRunUpdate = async (
    request: RecurringInvestment
  ): Promise<SingleResponse<RecurringInvestment>> =>
    this.accountNumberClient.update(
      request,
      RECURRING_INVESTMENT_REQUEST_DESER.serialize,
      RECURRING_INVESTMENT_DESER.update,
      "recurring-investments/:recurringInvestmentId/dry-run",
      {
        accountNumber: request.accountNumber,
        recurringInvestmentId: request.id,
      }
    )
}
